import React, {Component} from 'react'
import {addLocaleData, IntlProvider} from 'react-intl'
import {withStyles} from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import platform from 'platform'
import es from 'react-intl/locale-data/es'
import en from 'react-intl/locale-data/en'
import pt from 'react-intl/locale-data/pt'
import vi from 'react-intl/locale-data/vi'
import {EN, IOS, ANDROID} from './constants'
import messages_en from './translations/en.json'
import messages_es from './translations/es.json'
import messages_pt from './translations/pt.json'
import messages_vi from './translations/vi.json'
import getParameterByName from './utils'
import Header from './components/Header'
import Footer from './components/Footer'
import Login from './components/Login'
import FrameSizer from './components/FrameSizer'
import ShowFrameSize from './components/ShowFrameSize'
import CustomExitUrl from './components/CustomExitUrl'
import LocalhostLoader from './components/LocalhostLoader'
import Notification from './components/Notification'
import {ContextProvider} from './Context'

const messages = {
  en: messages_en,
  es: messages_es,
  pt: messages_pt,
  vi: messages_vi,
}
const availableSiteIds = [
  'Default',
  'BN',
  'EURO',
  'PH',
  'SBG',
  'SBGCASINO',
  'DPSPORTS',
  'AH',
]

addLocaleData([...en, ...es, ...pt, ...vi])

const host = getParameterByName('host') || 'https://devint.tazpool.com'
const domain = host.split('.')[1]
const subDomain = host.split('.')[0].split('//')[1]
const isMobile = platform.os.family === IOS || platform.os.family === ANDROID

const styles = () => ({
  wrapper: {
    width: '100%',
    height: '100%',
  },
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  iFrame: {
    position: 'absolute',
    top: 70,
    left: '50%',
    transform: 'translateX(-50%)',
    background: 'grey',
    border: 'none',
    borderRadius: 10,
    overflow: 'hidden',
  },
})

class App extends Component {
  state = {
    notify: false,
    authorized: false,
    notifyMessage: 'noMatch',
    password: '',
    username: '',
    localhost: 'https://localhost',
    language: EN,
    showPassword: false,
    siteId: 'Default',
    openIFrame: false,
    openInNewWindowChecked: false,
    sweepstakesPlatformChecked: false,
    openInIFrameChecked: false,
    loadLocalhost: false,
    localhostScrolling: true,
    iFrameSrc: null,
    notifyVPN: false,
    frameWidth: 1220,
    frameHeight: 750,
    customExitUrl: '',
    showCustomExitUrlInput: false,
    smsAuth: false,
    smsAuthCode: false,
    phoneNumber: '',
    smsCode: '',
    loading: false,
  }

  getCredentials = async (username, password) => {
    this.setState({
      ...this.state,
      loading: true,
    })
    try {
      const data = await fetch(
        `${host}/auth?username=${username}&password=${password}&ui=none&r=${Math.random()}`,
      ).then(response => response.json())
      const {authorized, token, userId} = data
      this.setState({
        ...this.state,
        notify: !authorized,
        authorized,
        loading: false,
      })
      const platform = isMobile ? 'mobile' : 'desktop'
      if (authorized) {
        document.location = `${host}/${platform}/v2?token=${token}&userId=${userId}&pinsOnly=False&lang=en&siteId=&exitUrl=${host}&lobbyUrl=undefined&skinConfigUrl=`;
      }
    } catch (err) {
      this.setState({
        ...this.state,
        notify: true,
        authorized: false,
        loading: false,
      })
    }
  }

  handleChange = prop => event => {
    this.setState({[prop]: event.target.value})
  }

  handleChecked = name => event => {
    this.setState({
      [name]: event.target.checked,
    })

    if ([name][0] === 'openInNewWindowChecked') {
      this.setState({
        openInIFrameChecked: false,
      })
    }

    if ([name][0] === 'openInIFrameChecked') {
      this.setState({
        openInNewWindowChecked: false,
      })
    }

    if ([name][0] === 'sweepstakesPlatformChecked') {
      this.setState({
        notifyVPN: event.target.checked,
      })
    }

    if ([name][0] === 'showCustomExitUrlInput') {
      this.setState({
        showCustomExitUrlInput: event.target.checked,
      })
    }
  }

  handleMouseDownPassword = event => {
    event.preventDefault()
  }

  handleClickShowPassword = () => {
    this.setState({showPassword: !this.state.showPassword})
  }

  handleCloseNotification = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    this.setState({notify: false})
  }

  handleKeyPressSendForm = event => {
    if (event.key === 'Enter') {
      this.handleSendForm()
    }
  }

  handleOpenIFrame = authUrl => {
    this.setState({
      openIFrame: true,
      iFrameSrc: authUrl,
    })
  }

  handleCloseIFrame = () => {
    this.setState({
      openIFrame: false,
      iFrameSrc: null,
    })
  }

  handleSendForm = () => {
    const {
      username,
      password,
      openInNewWindowChecked,
      openInIFrameChecked,
      sweepstakesPlatformChecked,
      siteId,
      localhost,
      loadLocalhost,
      customExitUrl,
    } = this.state

    if (loadLocalhost) {
      this.handleOpenIFrame(localhost)
      this.setState({notify: false})
      return
    }

    if (username === '' || password === '') {
      this.setState({notify: true})
      return
    }

    const skinStuff =
      siteId === null || siteId === 'Default'
        ? ''
        : `&siteId=${siteId}&agentId=taz&currencyId=USD&SGB-Simulation=True`
    const exitUrl = openInNewWindowChecked
      ? 'CLOSE'
      : customExitUrl
      ? customExitUrl
      : host
    const newHost = sweepstakesPlatformChecked ? 'www.acereveal.com' : host

    const newHostWithProtocol = newHost.includes('http')
      ? newHost
      : `https://${newHost}`

    const authUrl = `${newHostWithProtocol}/auth/?username=${username}&password=${password}${skinStuff}&exitUrl=${exitUrl}&lang=${this.state.language}`

    if (openInIFrameChecked) {
      this.handleOpenIFrame(authUrl)
      this.setState({notify: false})
      return
    }

    if (openInNewWindowChecked) {
      window.open(authUrl)
    } else {
      // document.location = authUrl
      this.getCredentials(username, password)
    }
    this.setState({notify: false})
  }

  handleSendCode = async () => {
    const {phoneNumber, sweepstakesPlatformChecked} = this.state

    const newHost = sweepstakesPlatformChecked ? 'www.acereveal.com' : host

    const newHostWithProtocol = newHost.includes('http')
      ? newHost
      : `https://${newHost}`
    const auth = `${newHostWithProtocol}/auth-phone?number=${window.encodeURIComponent(
      phoneNumber,
    )}`
    try {
      const res = await fetch(auth, {method: 'POST'})

      if (!res.ok) {
        return
      }

      const {result} = await res.json()
      if (!result) {
        this.setState({
          notify: true,
          notifyMessage: 'NumberIsNotValid',
        })
        return
      }
      this.setState({
        smsAuthCode: true,
      })
    } catch ({message}) {
      // do something here
    }
  }

  handleVerifyCode = async () => {
    const {
      phoneNumber,
      smsCode,
      openInNewWindowChecked,
      openInIFrameChecked,
      sweepstakesPlatformChecked,
      siteId,
      customExitUrl,
    } = this.state

    const newHost = sweepstakesPlatformChecked ? 'www.acereveal.com' : host

    const newHostWithProtocol = newHost.includes('http')
      ? newHost
      : `https://${newHost}`
    const auth = `${newHostWithProtocol}/auth-phone-verification?number=${window.encodeURIComponent(
      phoneNumber,
    )}&code=${window.encodeURIComponent(smsCode)}`
    try {
      const res = await fetch(auth, {method: 'POST'})

      if (!res.ok) {
        return
      }

      const {result, url} = await res.json()
      if (!result) {
        this.setState({
          notify: true,
          notifyMessage: 'codeIsNotValid',
        })
        return
      }
      const skinStuff =
        siteId === null || siteId === 'Default'
          ? ''
          : `&siteId=${siteId}&agentId=taz&currencyId=USD&SGB-Simulation=True`
      const exitUrl = openInNewWindowChecked
        ? 'CLOSE'
        : customExitUrl
        ? customExitUrl
        : host
      const newHost = sweepstakesPlatformChecked ? 'www.acereveal.com' : host

      const newHostWithProtocol = newHost.includes('http')
        ? newHost
        : `https://${newHost}`

      const authUrl = `${newHostWithProtocol}${url}${skinStuff}&exitUrl=${exitUrl}&lang=${this.state.language}`

      if (openInIFrameChecked) {
        this.handleOpenIFrame(authUrl)
        this.setState({notify: false})
        return
      }

      if (openInNewWindowChecked) {
        window.open(authUrl)
      } else {
        document.location = authUrl
      }
    } catch ({message}) {
      // do something here
    }
  }

  handleSetLanguage = language => {
    this.setState({
      language: language,
    })
  }

  handleSetSiteId = siteId => {
    this.setState({
      siteId: siteId,
    })
  }

  handleChangeH = (event, value) => {
    this.setState({frameHeight: value})
  }

  handleChangeW = (event, value) => {
    this.setState({frameWidth: value})
  }

  render() {
    const {classes} = this.props
    const {
      notify,
      notifyMessage,
      notifyVPN,
      password,
      username,
      language,
      showPassword,
      openInNewWindowChecked,
      openInIFrameChecked,
      siteId,
      openIFrame,
      iFrameSrc,
      sweepstakesPlatformChecked,
      frameHeight,
      frameWidth,
      localhost,
      loadLocalhost,
      localhostScrolling,
      customExitUrl,
      showCustomExitUrlInput,
      smsAuth,
      smsAuthCode,
      phoneNumber,
      smsCode,
      loading,
    } = this.state
    return (
      <IntlProvider
        locale={language}
        key={language}
        messages={messages[language]}>
        <ContextProvider
          value={{
            isDemo: subDomain === 'demo',
            domain,
            subDomain,
            isMobile,
            language,
            openInNewWindowChecked,
            openInIFrameChecked,
            siteId,
            availableSiteIds,
            sweepstakesPlatformChecked,
            notify,
            notifyMessage,
            notifyVPN,
            password,
            showPassword,
            username,
            openIFrame,
            iFrameSrc,
            frameHeight,
            frameWidth,
            localhost,
            localhostScrolling,
            customExitUrl,
            smsAuth,
            smsAuthCode,
            phoneNumber,
            smsCode,
            loading,
            showCustomExitUrlInput,
            handleSetLanguage: this.handleSetLanguage,
            handleSetSiteId: this.handleSetSiteId,
            handleChange: this.handleChange,
            handleChecked: this.handleChecked,
            handleCloseModal: this.handleCloseModal,
            handleSendForm: this.handleSendForm,
            handleSendCode: this.handleSendCode,
            handleVerifyCode: this.handleVerifyCode,
            handleKeyPress: this.handleKeyPressSendForm,
            handleMouseDownPassword: this.handleMouseDownPassword,
            handleClickShowPassword: this.handleClickShowPassword,
            handleCloseNotification: this.handleCloseNotification,
            handleChangeH: this.handleChangeH,
            handleChangeW: this.handleChangeW,
          }}>
          <div className={classes.wrapper}>
            <Header />
            <div className={classes.container}>
              {(openInIFrameChecked || loadLocalhost) && <ShowFrameSize />}
              {!loadLocalhost && <Login />}
              {openInIFrameChecked && <FrameSizer />}
              {showCustomExitUrlInput && <CustomExitUrl />}
              {loadLocalhost && <LocalhostLoader />}
              <Footer name={subDomain} />
              {!isMobile && <Notification />}
              <Modal
                aria-labelledby="open-i-frame"
                aria-describedby="open the lobby in an iFrame"
                open={openIFrame}
                onClose={this.handleCloseIFrame}>
                <iframe
                  src={iFrameSrc}
                  title="Lobby"
                  className={classes.iFrame}
                  style={{
                    height: frameHeight,
                    width: frameWidth,
                  }}
                  scrolling={localhostScrolling ? 'yes' : 'no'}
                />
              </Modal>
            </div>
          </div>
        </ContextProvider>
      </IntlProvider>
    )
  }
}

export default withStyles(styles)(App)



// WEBPACK FOOTER //
// ./src/App.js